import createSvgIcon from '@mui/material/utils/createSvgIcon.js';
import React from 'react';

export default createSvgIcon(
  <path
    fillRule="evenodd"
    d="m17.714 2.3597 4.0406 4.0406c.4463.4463.4463 1.17 0 1.6162l-4.0405 4.0404.808.8084c.4463.4463.4463 1.1699 0 1.6162l-4.0406 4.0406c-.4463.4463-1.17.4463-1.6162 0l-.8084-.808-4.0404 4.0405c-.4463.4463-1.1699.4463-1.6162 0L2.3597 17.714c-.4463-.4463-.4463-1.17 0-1.6162l4.0401-4.0409-.8076-.8079c-.4463-.4463-.4463-1.17 0-1.6162l4.0406-4.0406c.4463-.4463 1.17-.4463 1.6162 0l.808.8076 4.0408-4.0401c.4463-.4463 1.1699-.4463 1.6162 0M4.7838 15.2889l-1.616 1.617 4.0406 4.0406L8.8238 19.33zm2.4229-2.4251-1.6149 1.6171 4.04 4.0412 1.616-1.6172zm3.2342-6.4635-4.0406 4.0406 7.273 7.2731 4.0407-4.0406zm4.04-.8085-1.6171 1.6149 4.0411 4.0411 1.6172-1.616zm2.425-2.424-1.617 1.616 4.0412 4.04 1.6164-1.6154z"
  />,
  'Satellite',
);
